import {Content} from "antd/es/layout/layout";
import {Button, Input, Space} from "antd";
import {useState} from "react";
import {AppConstants, GetWebServiceUrl, LoginBasicAuth} from "../utils/constants";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import {LockOutlined, UserOutlined, WarningOutlined} from "@ant-design/icons";
import NotificationHeader, {SetNotification, SetNotificationWithoutDismiss} from "../utils/notification";

let username;
let password;
let confirmPassword;
export default function RegisterPage() {
    const [loadings, setLoadings] = useState([]);
    const [errors, setErrors] = useState([]);

    const navigation = useNavigate();
    const onChangeUsername = (value) => {
        username = value;

    }

    const onChangePassword = (value) => {
        password = value;
    }

    const onChangeConfirmPassword = (value) => {
        confirmPassword = value;
    }

    const register = async () => {
        clearErrors()
        console.log("register")
        if (username === undefined || username === "") {
            addError(0)
            return
        }
        if (password === undefined || password === "") {
            addError(1)
            return
        }
        if (confirmPassword === undefined || confirmPassword === "") {
            addError(2)
            return
        }
        if (confirmPassword !== password) {
            console.log("ERR", "index")
            addError(1)
            addError(2)
            return
        }
        enterLoading(0)
        let response = await axios.get(GetWebServiceUrl(AppConstants.REGISTER), LoginBasicAuth(username, password)).catch(err => {
            console.log("ERR", err.response.data)
            SetNotificationWithoutDismiss("Error", err.response.status + "\n" + JSON.stringify(err.response.data.message), "danger");
            setLoadings((prevLoadings) => {
                const newLoadings = [...prevLoadings];
                newLoadings[0] = false;
                return newLoadings;
            });
            return
        })

        if (response !== undefined && response.status === 200) {
            setLoadings((prevLoadings) => {
                const newLoadings = [...prevLoadings];
                newLoadings[0] = false;
                return newLoadings;
            });
            navigation("/");
            console.log(response)
        }
    }


    const enterLoading = (index) => {
        setLoadings((prevLoadings) => {
            const newLoadings = [...prevLoadings];
            newLoadings[index] = true;
            return newLoadings;
        });
        setTimeout(() => {
            setLoadings((prevLoadings) => {
                const newLoadings = [...prevLoadings];
                newLoadings[index] = false;
                return newLoadings;
            });
        }, 6000);
    };


    const addError = (index) => {
        console.log(index)
        setErrors((prevErrors) => {
            const newErrors = [...prevErrors];
            newErrors[index] = "error";
            return newErrors;
        });
    };

    const clearErrors = () => {
        setErrors((prevErrors) => {
            const newErrors = [...prevErrors];
            for (let i = 0; i < newErrors.length; i++) {
                newErrors[i] = ""
            }
            return newErrors
        });
    };

    return (
        <>
            <NotificationHeader></NotificationHeader>
            <div style={{
                padding: 0,
                height: "100vh",
                alignContent: "center",
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center"
            }}>
                <div style={{minWidth: "35%"}}>
                    <h1 style={{textAlign: "center"}}>Register</h1>
                    <Content style={{margin: "auto"}}>
                        <Space direction="vertical" style={{width: "100%", margin: "auto",}}>
                            <Input status={errors[0]} prefix={<UserOutlined/>} allowClear
                                   onChange={(e) => onChangeUsername(e.target.value)} placeholder="Username"/>
                            <Input.Password status={errors[1]} prefix={<LockOutlined/>}
                                            onChange={(e) => onChangePassword(e.target.value)} placeholder="Password"/>
                            <Input.Password status={errors[2]} prefix={<LockOutlined/>}
                                            onChange={(e) => onChangeConfirmPassword(e.target.value)}
                                            placeholder="Confirm Password"/>
                            <Button loading={loadings[0]} onClick={() => register()} size={'middle'} type={"primary"}
                                    style={{width: "100%"}}>Register</Button>
                        </Space>
                    </Content>
                </div>
            </div>
        </>

    )
}